<template>
  <div id="viewIdle" style="padding-bottom:30px" v-if="data" class="container">
    <div class="box" v-if="data">
      <el-row :gutter="50">
        <el-col :span="8">
          <el-image
            class="cover"
            :src=" serve + '/'+_.split(data.results.images, ';', 1)"
            fit="cover"
          ></el-image>
        </el-col>
        <el-col :span="16">
          <div class="t1 lv1Text">{{data.results.title}}</div>
          <div class="b1 lv3Text">
            <div class="t2">
              闲置价：
              <span class="lv0Text">&yen;{{data.results.selling_price}}</span>
            </div>
            <div class="t3">
              原价：
              <s>
                <span class="lv2Text">&yen;{{data.results.original_price}}</span>
              </s>
            </div>
          </div>
          <div class="d1">
            <el-row>
              <el-col :span="3" class="c1">
                <el-image
                  class="avatar"
                  style="width: 50px; height: 50px"
                  :src="data.seller.headImg"
                  fit="cover"
                ></el-image>
              </el-col>
              <el-col :span="21">
                <span class="name">{{data.seller.nickname}}</span>
              </el-col>
            </el-row>
            <el-button type="primary" @click="buy" style="width:150px;height:50px">立即购买</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="box2">
      <el-row :gutter="30">
        <el-col :span="18">
          <div class="col">
            <div class="lv1Text" style="font-size:20px;text-align:center;padding:20px">商品描述</div>
            <div style="padding:20px;word-wrap:break-word; ">{{data.results.info}}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="col">
            <div style="padding:20px">
              <div align="center">
                其他闲置好物
                <el-button type="text" style="margin-left:10px" @click="loadTop4">
                  <i class="fas fa-undo"></i>换一批
                </el-button>
              </div>
              <div>
                <div v-for="(item,index) of top4" :key="index" class="top4-item">
                  <div align="center">
                    <router-link :to="'viewIdle?id='+item.id">
                      <el-image
                        class="cover2"
                        style="width: 237px; height: 150px"
                        :src="serve + '/' +_.split(item.images, ';', 1)"
                        fit="cover"
                      ></el-image>
                    </router-link>
                    <div class="lv1Text d2">
                      <router-link :to="'viewIdle?id='+item.id">{{item.title}}</router-link>
                    </div>
                    <div class="lv0Text d3">&yen;{{item.selling_price}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      id: this.$route.query.id,
      data: null,
      top4: {}
    };
  },
  watch: {
    $route: "initData"
  },
  created() {
    this.$store.state.user_location = "闲置交换";
    this.$store.state.user_location2 = "商品详情";
    this.initData();
  },
  methods: {
    buy() {
      var data = this.data;
      this.$router.push({
        path: "/user/createidleorder",
        query: { data: JSON.stringify(data.results) }
      });
    },
    initData() {
      this.axios
        .get(this.serve + "/exchange_detail", {
          params: {
            id: this.$route.query.id
          }
        })
        .then(res => {
          this.data = res.data.data;
        });
      this.loadTop4();
    },
    loadTop4() {
      this.top4 = {};
      this.axios
        .get(this.serve + "/four_exchange", {
          params: {
            id: this.id
          }
        })
        .then(res => {
          this.top4 = res.data.data;
        });
    }
  }
};
</script>
<style lang="scss">
#viewIdle {
  .d2:hover {
    text-decoration: underline;
  }
  .d2 {
    padding: 10px 0 1px 0;
  }
  .d3 {
    padding: 2px 0 10px 0;
  }
  .top4-item {
    border: 1px solid #ddd;
    margin-bottom: 30px;
  }
  .c1 {
    margin-bottom: 20px;
  }
  .name {
    line-height: 50px;
  }
  .d1 {
    border: 1px solid #ddd;
    padding: 20px;
  }
  .avatar {
    border-radius: 50px;
    overflow: hidden;
  }
  padding-top: 40px;
  .box2 {
    margin-top: 20px;
    .col {
      background-color: #fff;
      border: 1px solid #ddd;
      width: 100%;
    }
  }
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 30px;
  }
  .cover {
    width: 346px;
    height: 346px;
  }
  .t1 {
    font-size: 30px;
    margin-bottom: 10px;
  }
  .b1 {
    background-color: #dedede;
    padding: 20px;
    margin-bottom: 20px;
    font-size: 16px;
    span {
      font-size: 22px;
    }
  }
  .t2 {
    margin-bottom: 10px;
  }
}
</style>

